import { Image } from 'foundations-components/transitional/components/Image';

// @ts-ignore svg import
import MarketingHubSvg from 'bender-url!./images/MarketingHub.svg';
import { MERCH_CARD_PRODUCT_ICON_STYLE_PROPS, PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS } from './styleProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingHubProductIcon = ({
  useCase = 'productPageTitle'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: MarketingHubSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};